"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.DeepFirst = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var lodash_1 = require("lodash");
var errors_1 = require("@ledgerhq/errors");
var types_1 = require("./types");
var utils = __importStar(require("../utils"));
var logs_1 = require("@ledgerhq/logs");
var DeepFirst = /** @class */ (function (_super) {
    __extends(DeepFirst, _super);
    function DeepFirst() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // eslint-disable-next-line class-methods-use-this
    DeepFirst.prototype.selectUnspentUtxosToUse = function (xpub, outputs, feePerByte) {
        return __awaiter(this, void 0, void 0, function () {
            var addresses, unspentUtxos, _a, outputAddresses, txSizeNoInput, fee, emptyTxSize, sizePerInput, sizePerOutput, total, unspentUtxoSelected, amount, i;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, xpub.getXpubAddresses()];
                    case 1:
                        addresses = _b.sent();
                        (0, logs_1.log)("picking strategy", "Deepfirst");
                        _a = lodash_1.flatten;
                        return [4 /*yield*/, Promise.all(addresses.map(function (address) { return xpub.storage.getAddressUnspentUtxos(address); }))];
                    case 2:
                        unspentUtxos = _a.apply(void 0, [_b.sent()]).filter(function (o) {
                            return !_this.excludedUTXOs.filter(function (x) { return x.hash === o.output_hash && x.outputIndex === o.output_index; }).length;
                        });
                        outputAddresses = outputs.map(function (o) { return o.address; });
                        unspentUtxos = (0, lodash_1.sortBy)(unspentUtxos, "block_height");
                        txSizeNoInput = utils.maxTxSize(0, outputAddresses, false, this.crypto, this.derivationMode);
                        fee = txSizeNoInput * feePerByte;
                        emptyTxSize = utils.maxTxSizeCeil(0, [], false, this.crypto, this.derivationMode);
                        sizePerInput = utils.maxTxSize(1, [], false, this.crypto, this.derivationMode) -
                            emptyTxSize;
                        sizePerOutput = (outputAddresses[0]
                            ? utils.maxTxSize(0, [outputAddresses[0]], false, this.crypto, this.derivationMode)
                            : utils.maxTxSize(0, [], true, this.crypto, this.derivationMode)) -
                            emptyTxSize;
                        total = new bignumber_js_1["default"](0);
                        unspentUtxoSelected = [];
                        amount = outputs.reduce(function (sum, output) { return sum.plus(output.value); }, new bignumber_js_1["default"](0));
                        i = 0;
                        while (total.lt(amount.plus(fee))) {
                            if (!unspentUtxos[i]) {
                                throw new errors_1.NotEnoughBalance();
                            }
                            total = total.plus(unspentUtxos[i].value);
                            unspentUtxoSelected.push(unspentUtxos[i]);
                            fee += sizePerInput * feePerByte;
                            i += 1;
                        }
                        if (total.minus(amount.plus(fee)).lt(sizePerOutput * feePerByte)) {
                            // not enough fund to make a change output
                            return [2 /*return*/, {
                                    totalValue: total,
                                    unspentUtxos: unspentUtxoSelected,
                                    fee: Math.ceil(fee),
                                    needChangeoutput: false
                                }];
                        }
                        fee += sizePerOutput * feePerByte; // fee to make a change output
                        return [2 /*return*/, {
                                totalValue: total,
                                unspentUtxos: unspentUtxoSelected,
                                fee: Math.ceil(fee),
                                needChangeoutput: true
                            }];
                }
            });
        });
    };
    return DeepFirst;
}(types_1.PickingStrategy));
exports.DeepFirst = DeepFirst;
//# sourceMappingURL=DeepFirst.js.map